import { computed, reactive, toValue, type MaybeRefOrGetter } from 'vue'
import type { LessonImpulseSummary } from '../models/lesson-impulse'
import {
  lessonImpulseFilterOptions,
  matchesLessonImpulseFilters,
  type LessonImpulseFilters,
} from '../models/lesson-impulse-filters'

export const useLessonImpulseFilters = (
  impulses: MaybeRefOrGetter<ReadonlyArray<LessonImpulseSummary> | undefined>,
) => {
  const filters = reactive<LessonImpulseFilters>({
    kompetenzIds: [],
    grades: [],
    subjectCodes: [],
    bookmarkedOnly: false,
  })

  const options = computed(() => lessonImpulseFilterOptions(toValue(impulses) ?? []))

  const hasFilter = computed(
    () =>
      filters.kompetenzIds.length > 0 ||
      filters.grades.length > 0 ||
      filters.subjectCodes.length > 0 ||
      filters.bookmarkedOnly,
  )

  const toggleValue = <T>(values: T[], value: T) => {
    const index = values.indexOf(value)
    if (index === -1) {
      values.push(value)
    } else {
      values.splice(index, 1)
    }
  }

  const toggleKompetenz = (id: string) => toggleValue(filters.kompetenzIds, id)
  const toggleGrade = (grade: number) => toggleValue(filters.grades, grade)
  const toggleSubject = (code: string) => toggleValue(filters.subjectCodes, code)
  const toggleBookmarked = () => {
    filters.bookmarkedOnly = !filters.bookmarkedOnly
  }

  const resetFilters = () => {
    filters.kompetenzIds = []
    filters.grades = []
    filters.subjectCodes = []
    filters.bookmarkedOnly = false
  }

  const applyFilters = (list: ReadonlyArray<LessonImpulseSummary> | undefined) =>
    (list ?? []).filter((impulse) => matchesLessonImpulseFilters(impulse, filters))

  return {
    filters,
    options,
    hasFilter,
    toggleKompetenz,
    toggleGrade,
    toggleSubject,
    toggleBookmarked,
    resetFilters,
    applyFilters,
  }
}
